import { render, staticRenderFns } from "./openroom.vue?vue&type=template&id=61590f74&scoped=true"
import script from "./openroom.vue?vue&type=script&lang=js"
export * from "./openroom.vue?vue&type=script&lang=js"
import style0 from "./openroom.vue?vue&type=style&index=0&id=61590f74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61590f74",
  null
  
)

export default component.exports